import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { AnalyticsEventName } from '@/api/analytics';
import { ButtonClose, ButtonWithArray } from '@/components/buttons';
import { Modals } from '@/helpers/modals';
import { useAnalytics } from '@/hooks/analytics';
import { useGameThemes } from '@/hooks/game';
import { useNavigation } from '@/hooks/navigation';
import { useModalsStore } from '@/store';

import { ScTopicsSelect } from './styled';

export interface ITopicsProps {
  categoryId?: string;
}

export const Topics: FC<ITopicsProps> = ({ categoryId }) => {
  const { t } = useTranslation('common');
  const { navigate } = useNavigation();
  const open = useModalsStore.use.open();

  const { sendEventToAnalytics } = useAnalytics();

  const { currentGameTheme } = useGameThemes(categoryId);

  const resetTopic = () => {
    navigate('/', true);
  };

  const handleButtonClick = useCallback(async () => {
    await sendEventToAnalytics({
      name: AnalyticsEventName.LOBBY__FILTER_GAMES__ALL_THEMES__CLICK,
    });

    open(Modals.Topics);
  }, [open, sendEventToAnalytics]);

  return (
    <ScTopicsSelect>
      <ButtonWithArray
        selected={!!currentGameTheme}
        onClick={handleButtonClick}
      >
        {currentGameTheme?.title || t('topics.btnAll')}
      </ButtonWithArray>
      {currentGameTheme && (
        <ButtonClose right={0} top={0} className="close" onClick={resetTopic} />
      )}
    </ScTopicsSelect>
  );
};
